import { AllModules, LicenseManager, ModuleRegistry, provideGlobalGridOptions } from '@ag-grid-enterprise/all-modules';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from 'src/app/app.module';
import { environment } from 'src/environments/environment';

if (environment.production) {
  enableProdMode();
}

// ag-Grid 33+: register the modules once for every grid, and keep the CSS/Sass themes (_ag-grid.scss)
// instead of the Theming API that 33 turns on by default (same as agrclient)
ModuleRegistry.registerModules(AllModules);
// ag-Grid 35 adds "No matching rows" and "Exporting" overlays; suppressed to keep the grids as they were
provideGlobalGridOptions({ theme: 'legacy', suppressOverlays: ['noMatchingRows', 'exporting'] });

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.log(err);
  });

// The AG-Grid License
// Also added in session.service.spec.ts for unit tests
LicenseManager.setLicenseKey(
  // eslint-disable-next-line max-len
  'Using_this_{AG_Grid}_Enterprise_key_{AG-084221}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{App_Dynamic_ehf.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{AGR5}_only_for_{4}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{AGR5}_need_to_be_licensed___{AGR5}_has_been_granted_a_Deployment_License_Add-on_for_{73}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{27_November_2026}____[v3]_[01]_MTc5NTczNzYwMDAwMA==e630e4395732725614c010eed68f370f'
);
